export const dayjsVocab: Record<string, any> = {
  en: "en",
  de: "de",
  es: "es",
  fr: "fr",
  ru: "ru",
  cn: "zh-cn",
  am: "hy-am",
};
